import React from 'react';
import { bool, func, number, string, shape } from 'prop-types';
import { UTButton } from '@widergy/energy-ui';

import SecondaryTopbar from 'app/components/SecondaryTopbar';
import { appConfig } from 'config/customization';
import UTList from 'app/components/UTList';
import { message } from 'utils/stringUtils';

import DeleteAccount from '../AccountList/components/DeleteAccount';

import styles from './styles.module.scss';

const AccountDetail = ({
  formattedAccount,
  deleteModalIsOpen,
  onDeleteAccount,
  deleteAccountId,
  deleteAccountLoading,
  onDeleteModalClose,
  onDeleteModalOpen
}) => (
  <div>
    <SecondaryTopbar titleText={message('AccountDetails:detail')} />
    <UTList list={formattedAccount} style={styles.list} />
    {appConfig.deleteAccount && (
      <div className={styles.bottomContainer}>
        <UTButton onPress={onDeleteModalOpen}>{message('Accounts:deleteAccount')}</UTButton>
        <DeleteAccount
          deleteModalIsOpen={deleteModalIsOpen}
          onDeleteModalClose={onDeleteModalClose}
          onDeleteAccount={onDeleteAccount}
          deleteAccountId={deleteAccountId}
          deleteAccountLoading={deleteAccountLoading}
        />
      </div>
    )}
  </div>
);

AccountDetail.propTypes = {
  formattedAccount: shape({
    id: number,
    title: string,
    subtitle: string
  }),
  deleteModalIsOpen: bool,
  onDeleteAccount: func,
  deleteAccountId: number,
  deleteAccountLoading: bool,
  onDeleteModalClose: func,
  onDeleteModalOpen: func
};

export default AccountDetail;
